import BranchApi from 'api/branch';
import DealerApi from 'api/dealer';
import events from 'lib/events';
import Header from 'components/layout/header';
import IntlWrapper from 'components/layout/intlWrapper';
import moment from 'moment';
import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import ReportApi from 'api/report';
import router from 'lib/router';
import routeUtils from 'util/routeUtils';
import session from 'services/sessionService';
import stateStore from 'util/stateStore';
import SummaryReport from './components/summaryReport';
import {connectToPerformanceFile, PERFORMANCE_KEYS} from 'ui/helpers/performanceFile';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import {dateTimeFormats} from 'helpers/constants';

const render = (container) => {
  console.info('[UI.page.reports] rendering page');
  ReactDOM.render(<IntlWrapper><LandingReports /> </IntlWrapper>, container);
  events.publish('page-change', {page: 'reports'});
};

console.info('[UI.page.reports] register route');
router.rr.add([{path: 'reports/', handler: routeUtils.requireAdmin(render)}]);

class _LandingReports extends Component {
  static propTypes = {
    intl: intlShape.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      start: moment().subtract(30, 'day'),
      end: moment(),
      stores: [],
      loaded: false,
    };
  }

  componentWillMount() {
    this.getUser()
      .then(res => {
        this.setState({
          blocks: this.getBlocks(),
        });
      })
      .then(() => {
        this.getDealer();
      });
  }

  componentDidMount() {
    BranchApi.getMyBranches()
      .then(branches => {
        this.setState({stores: branches});
      });
  }

  /* ========================================================================
   * Get the block array
   * ======================================================================== */
  getBlocks = () => {
    let {formatMessage} = this.props.intl;
    let blocks = [
      {
        title: formatMessage({id: 'reports.followups'}),
        getColumns: this.getSimpleFollowUpReportColumns,
        description: formatMessage({id: 'reports.followups.description'}),
        start: this.state.start,
        end: this.state.end,
        getData: this.updateFollowUpReport,
        dataKey: 'followups',
        icon: 'bl-myfollowups_report-small',
        buttons: [
          {link: '/#reports/followups/missing-customers', label: formatMessage({id: 'reports.followups.missing.customers'})},
          {link: '/#reports/followups/open-follow-ups', label: formatMessage({id: 'reports.followups.open.followups'})},
          {link: '/#reports/followups/completed-follow-ups', label: formatMessage({id: 'reports.followups.completed.followups'})},
          {link: '/#reports/followups/past-due', label: formatMessage({id: 'reports.followups.pastdue.followup'})},
        ],
      },
      {
        title: formatMessage({id: 'reports.customer.accounts'}),
        getColumns: this.getSimpleCustomerReportColumns,
        dataKey: 'customer',
        description: formatMessage({id: 'reports.customer.description'}),
        icon: 'bl-customer_report-small',
        getData: this.updateCustomerReport,
        start: this.state.start,
        end: this.state.end,
        buttons: [
          {link: '/#reports/customer/account-list', label: formatMessage({id: 'reports.customer.all.accounts'})},
          {link: '/#reports/customer/system-list', label: formatMessage({id: 'reports.customer.all.systems'})},
          {link: '/#reports/customer/new-accounts', label: formatMessage({id: 'reports.customer.new.accounts'})},
          {link: '/#reports/customer/trublue-accounts', label: formatMessage({id: 'reports.customer.trublue.accounts'})},
          {link: '/#reports/customer/missing-information', label: formatMessage({id: 'reports.customer.missing.information'})},
        ],
      },
      {
        title: formatMessage({id: 'reports.water.analyses'}),
        getColumns: this.getSimpleWaterReportColumns,
        description: formatMessage({id: 'reports.water.analyses.description'}),
        start: this.state.start,
        end: this.state.end,
        getData: this.updateWaterTestsReport,
        dataKey: 'water',
        icon: 'bl-mywateranalysis_report-small',
        buttons: [
          {link: '/#reports/water/total-water-analyses', label: formatMessage({id: 'general.total.water.analyses'})},
          {link: '/#reports/water/analysis-accounts', label: formatMessage({id: 'general.water.analysis.accounts'})},
          {link: '/#reports/water/analyses-by-employee', label: formatMessage({id: 'general.analyses.employee'})},
        ],
      },
      {
        title: formatMessage({id: 'reports.bioguard.products'}),
        getColumns: this.getSimpleFollowUpReportColumns,
        description: formatMessage({id: 'reports.bioguard.products.description'}),
        start: this.state.start,
        end: this.state.end,
        getData: this.updateFollowUpReport,
        dataKey: 'followUp',
        icon: 'bl-mybioguardproducts_report-small',
        buttons: [
          {link: '/#reports/bioguard/recommended-products', label: formatMessage({id: 'reports.products.recommended'})},
          {link: '/#reports/bioguard/season-usage', label: formatMessage({id: 'reports.season.usage'})},
        ],
      },
      {
        title: formatMessage({id: 'reports.communications'}),
        getColumns: this.getSimpleFollowUpReportColumns,
        description: formatMessage({id: 'reports.communications.description'}),
        start: this.state.start,
        end: this.state.end,
        getData: this.updateFollowUpReport,
        dataKey: 'communications',
        icon: 'bl-mycommunications_report-small',
        buttons: [
          {link: '/#reports/communications/outbound-emails', label: formatMessage({id: 'reports.communications.outbound.emails'})},
          {link: '/#reports/communications/optout-emails', label: formatMessage({id: 'reports.communications.optout.emails'})},
        ],
      },
    ];

    return blocks;
  };


  getDealer = () => {
    DealerApi.getDealer(session.getUser().dealerId)
      .then(res => {
        this.setState({
          dealer: res,
          loaded: true,
          user: session.getUser(),
        });
      });
  };

  getPOSBlocks = (blocks) => {

    if(this.checkPOSPermission()) {
      let {formatMessage} = this.props.intl;    let mySales = {
        title: formatMessage({id: 'reports.my.sales'}),
        getColumns: this.getSimpleCustomerReportColumns,
        dataKey: 'sales',
        description: formatMessage({id: 'reports.sales.description'}),
        icon: 'bl-mysales_report-small',
        getData: this.updateCustomerReport,
        start: this.state.start,
        end: this.state.end,
        buttons: [
          {link: '/#reports/sales/sales-performance', label: formatMessage({id: 'reports.sales.performance'})},
          {link: '/#reports/sales/lost-purchasing-accounts', label: formatMessage({id: 'reports.lost.purchasing.accounts'})},
        ],
      };

      blocks.splice(1,0,mySales);

      var lastTile = blocks[4].buttons.pop();

      blocks[4].buttons.push({link: '/#reports/bioguard/product-sales', label: formatMessage({id: 'reports.product.sales'}), posOnly: true});
      blocks[4].buttons.push({link: '/#reports/bioguard/missed-products', label: formatMessage({id: 'reports.missed.product.sales'}), posOnly: true});
      blocks[4].buttons.push(lastTile);
    }

    return blocks;
  };

  /* ========================================================================
   * Get the formatted customer object
   * ======================================================================== */
  getSimpleCustomerReportColumns(data) {
    return [
      {
        label: 'Total Customers',
        width: 2,
        value: data.countCustomer || 0,
      },
      {
        label: 'Active',
        width: 2,
        value: data.countActive || 0,
      },
      {
        label: 'Inactive',
        width: 2,
        value: (data.countCustomer || 0) - (data.countActive || 0),
      },
      {
        label: 'Pools',
        width: 2,
        value: data.countPool || 0,
      },
      {
        label: 'Spas',
        width: 2,
        value: data.countSpa || 0,
      },
      {
        label: 'Swim Spas',
        width: 2,
        value: data.countSwimSpa || 0,
      },
    ];
  }

  getSimpleEmailReportColumns = (data = {}) => {
    return [
      {
        label: 'Welcome',
        width: 3,
        value: data.welcome || 0,
      },
      {
        label: 'Inactive',
        width: 3,
        value: data.inactive || 0,
      },
      {
        label: 'Past Due',
        width: 3,
        value: data.pastDue || 0,
      },
      {
        label: 'Problem Follow-Up',
        width: 3,
        value: data.problemFollowUp || 0,
      },
      {
        label: 'Pool Closing',
        width: 3,
        value: data.poolClosing || 0,
      },
      {
        label: 'Product Reminder',
        width: 3,
        value: data.productReminder || 0,
      },
      {
        label: 'Seasons Opening',
        width: 3,
        value: data.seasonOpening || 0,
      },
      {
        label: 'Calendar Reminder',
        width: 3,
        value: data.calendarReminder || 0,
      },
      {
        label: 'Encyclopedia',
        width: 3,
        value: data.encyclopedia || 0,
      },
      {
        label: 'Analysis',
        width: 3,
        value: data.analysis || 0,
      },
      {
        label: 'Date Start',
        width: 3,
        value: this.state.start.format(dateTimeFormats.numeralDate),
      },
      {
        label: 'Date End',
        width: 3,
        value: this.state.end.format(dateTimeFormats.numeralDate),
      },
    ];
  };

  /* ========================================================================
   * Get the formatted employee metrics object
   * ======================================================================== */
  getSimpleEmployeeMetricsReportColumns = data => {
    return [
      {
        label: 'Number of Employees',
        width: 4,
        value: data.testers || 0,
      },
      {
        label: 'Total Tests',
        width: 4,
        value: data.totalTests || 0,
      },
      {
        label: 'Date Start',
        width: 2,
        value: this.state.start.format(dateTimeFormats.numeralDate),
      },
      {
        label: 'Date End',
        width: 2,
        value: this.state.end.format(dateTimeFormats.numeralDate),
      },
    ];
  };

  /* ========================================================================
   * Get the formatted follow-up metrics object
   * ======================================================================== */
  getSimpleFollowUpReportColumns = data => {
    return [
      {
        label: 'Open Follow-Ups',
        width: 3,
        value: data.openReports || 0,
      },
      {
        label: 'Clarity',
        width: 1,
        value: data.waterClarityReports || 0,
      },
      {
        label: 'Algae',
        width: 1,
        value: data.algaeReports || 0,
      },
      {
        label: 'Surface',
        width: 1,
        value: data.surfaceProblemReports || 0,
      },
      {
        label: 'Chlorine Demand',
        width: 2,
        value: data.chlorineDemandReports || 0,
      },
      {
        label: 'Date Start',
        width: 2,
        value: this.state.start.format(dateTimeFormats.numeralDate),
      },
      {
        label: 'Date End',
        width: 2,
        value: this.state.end.format(dateTimeFormats.numeralDate),
      },
    ];
  };

  getSimpleLostCustomerReportColumns = (data = {}) => {
    return [
      {
        label: 'Total Lost Puchasing Accounts',
        width: 3,
        value: data.total || 0,
      },
      {
        label: 'Avg. Puchasing Value',
        width: 3,
        value: '$' + (data.avg_purchase_value || 0),
      },
      {
        label: 'Total Lifetime Value',
        width: 3,
        value: '$' + (data.total_purchase_value || 0),
      },
      {
        label: 'Avg. Purchase Lifespan',
        width: 3,
        value: (data.avg_purchase_lifespan || 0) + ' Years',
      },
    ];
  };

  /* ========================================================================
   * Get the formatted customer object
   * ======================================================================== */
  getSimpleTruBlueReportColumns = data => {
    return [
      {
        label: 'Total Customers',
        width: 2,
        value: data.totalCustomers || 0,
      },
      {
        label: 'Active TB',
        width: 2,
        value: data.activeTruBlue || 0,
      },
      {
        label: 'Inactive TB',
        width: 2,
        value: data.inactiveTruBlue || 0,
      },
      {
        label: 'Never TB',
        width: 2,
        value: data.neverTruBlue || 0,
      },
      {
        label: 'Date Start',
        width: 2,
        value: this.state.start.format('MM/DD/YYYY'),
      },
      {
        label: 'Date End',
        width: 2,
        value: this.state.end.format('MM/DD/YYYY'),
      },
    ];
  };

  /* ========================================================================
   * Get the formatted water object
   * ======================================================================== */
  getSimpleWaterReportColumns = data => {
    return [
      {
        label: 'Count of Water Test Visits',
        width: 8,
        value: data.totalTests || 0,
      },
      {
        label: 'Date Start',
        width: 2,
        value: this.state.start.format(dateTimeFormats.numeralDate),
      },
      {
        label: 'Date End',
        width: 2,
        value: this.state.end.format(dateTimeFormats.numeralDate),
      },
    ];
  };

  getUser = () => {
    session.getUser();
    return new Promise(function(resolve, reject) {
      (function waitUser() {
        if (session.getUser()) {
          return resolve();
        }
        setTimeout(waitUser, 30);
      })();
    });
  };

  checkPOSPermission = () => {
    const {user, dealer} = this.state;

    if (!this.state.loaded) {
      return false;
    }

    if (user && dealer) {
      if (user && dealer && dealer.CurrentPOSIntegration === 0) {
        return false;
      }

      if (user.isDealerAdmin) {
        return true;
      }

      if (user.isAdmin && dealer.managerDetailedReporting) {
        return true;
      }

      if (user.isTestStation && dealer.testerDetailedReporting) {
        return true;
      }
    }

    return false;
  };


  checkTruBlueDealerStatus = () => {
    const {dealer} = this.state;

    if (!this.state.loaded) {
      return false;
    }

    return dealer && dealer.isTruBlueEligible;
  };


  updateCustomerReport = () => {
    return ReportApi.getSimpleCustomerReport(
      stateStore.reports.selectedBranches || this.state.stores.map(s => s.id)
    );
  };

  updateEmailReport = () => {
    return ReportApi.getSimpleEmailReport(
      this.state.start.format(),
      this.state.end.format(),
      stateStore.reports.selectedBranches || this.state.stores.map(s => s.id)
    );
  };

  updateEmployeeReport = () => {
    return ReportApi.getSimpleEmployeeMetricsReport(
      stateStore.reports.selectedBranches || this.state.stores.map(s => s.id),
      this.state.start.format(),
      this.state.end.format()
    );
  };

  updateFollowUpReport = () => {
    return ReportApi.getSimpleFollowUpReport(
      stateStore.reports.selectedBranches || this.state.stores.map(s => s.id),
      this.state.start.format(),
      this.state.end.format()
    );
  };

  updateLostCustomerReport = () => {
    return ReportApi.getLostCustomerReportSummary(
      stateStore.reports.selectedBranches || this.state.stores.map(s => s.id),
      [1,2,3], //All pool types
      moment().subtract(1, 'year').subtract(1, 'month').format('YYYY-MM-DD'),
      moment().subtract(1, 'year').subtract(1, 'day').format('YYYY-MM-DD'),
      moment().subtract(1, 'year').format('YYYY-MM-DD')
    );
  };

  updateTruBlueReport = () => {
    return ReportApi.getSimpleTruBlueReport(
      stateStore.reports.selectedBranches || this.state.stores.map(s => s.id),
      this.state.start.format(),
      this.state.end.format()
    );
  };

  updateWaterTestsReport = () => {
    return ReportApi.getSimpleWaterTestsReport(
      stateStore.reports.selectedBranches || this.state.stores.map(s => s.id),
      this.state.start.format(),
      this.state.end.format()
    );
  };

  render() {

    let blocks = this.getBlocks();

    blocks = this.getPOSBlocks(blocks);

    return (
      <div className='container'>
        <Header mainTitle={this.props.intl.formatMessage({id: 'reports.title'})} />
        <span className='title-description'><FormattedMessage id='reports.description' /></span>
        <div id='page-reports'>
          {
            blocks !== undefined && blocks !== null ?
              blocks.map(b => {
                return (
                  <SummaryReport
                    POS={this.checkPOSPermission()}
                    truBlue = {this.checkTruBlueDealerStatus()}
                    key={b.dataKey}
                    getColumns={b.getColumns}
                    title={b.title}
                    icon={b.icon}
                    description={b.description}
                    getData={b.getData.bind(this)}
                    buttons={b.buttons}
                    tooltip={b.tooltip}
                    endpoint={b.endpoint} />
                );
              }) :
              null
          }
        </div>
      </div>
    );
  }
}

const LandingReports = injectIntl(connectToPerformanceFile(PERFORMANCE_KEYS.reports)(_LandingReports));

export default LandingReports;
